import React from 'react';
import { useAppData } from '../AppContext';
import './Dealers.css';

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.23h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const MailIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const MapIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const GlobeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const PersonIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const Dealers = () => {
  const { dealers } = useAppData();
  return (
  <div className="dlr-page">
    {/* Hero */}
    <div className="dlr-hero">
      <div className="dlr-hero-inner">
        <span className="dlr-eyebrow">Authorized Distributors of ZingaMetall Bvba</span>
        <h1 className="dlr-hero-title">Our Dealers</h1>
        <p className="dlr-hero-sub">
          John Galt Zinga Technologies is ZINGA Metall's All India Distributor. We have appointed authorised dealers across India, Sri Lanka and Nepal to serve you better.
        </p>
      </div>
    </div>

    {/* Dealers grid */}
    <div className="dlr-content">
      <div className="dlr-container">
        <h2 className="dlr-section-title">Regional Dealer Network</h2>
        <div className="dlr-grid">
          {dealers.filter(d => !d.disabled).map((d, i) => (
            <div className="dlr-card" key={i}>
              <div className="dlr-card-header">
                <span className="dlr-region">{d.region}</span>
                <h3 className="dlr-name">{d.name}</h3>
              </div>
              <div className="dlr-card-body">
                <div className="dlr-detail">
                  <MapIcon />
                  <span>{d.address}</span>
                </div>
                {d.rep && (
                  <div className="dlr-detail">
                    <PersonIcon />
                    <span>{d.rep}</span>
                  </div>
                )}
                <div className="dlr-detail">
                  <PhoneIcon />
                  <span>{d.phone}</span>
                </div>
                <div className="dlr-detail">
                  <MailIcon />
                  <span>
                    <a href={`mailto:${d.email}`} className="dlr-link">{d.email}</a>
                    {d.altEmail && <><br /><a href={`mailto:${d.altEmail}`} className="dlr-link">{d.altEmail}</a></>}
                  </span>
                </div>
                {d.website && (
                  <div className="dlr-detail">
                    <GlobeIcon />
                    <a href={d.websiteUrl} target="_blank" rel="noopener noreferrer" className="dlr-link">{d.website}</a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Become a Dealer CTA */}
    <div className="dlr-cta-section">
      <div className="dlr-container">
        <div className="dlr-cta-grid">
          {/* Addresses */}
          <div className="dlr-addr-box">
            <h3>Sales & Corporate Headquarters</h3>
            <p>
              John Galt Zinga Technologies<br />
              208, Makhija Arcade, 35th Road,<br />
              Off Linking Road, Bandra (W),<br />
              Mumbai 400050<br />
              <strong>T:</strong> +91-22-26003255 &nbsp;|&nbsp; <strong>F:</strong> +91-22-26003252
            </p>

            <h3 style={{ marginTop: '28px' }}>Godown</h3>
            <p>
              C/O John Galt International<br />
              Plot F-2, MIDC Badlapur, 421503,<br />
              Dist. Thane, India<br />
              <strong>T:</strong> +91-251-2690120 &nbsp;|&nbsp; <strong>F:</strong> +91-251-2691550
            </p>

            <p style={{ marginTop: '16px' }}>
              <strong>M:</strong> +91-9372134903 / 9820325285<br />
              <strong>E:</strong>{' '}
              <a href="mailto:sales.zinga@johngalt.in" className="dlr-link-light">sales.zinga@johngalt.in</a> /{' '}
              <a href="mailto:zinga@johngalt.in" className="dlr-link-light">zinga@johngalt.in</a>
            </p>
          </div>

          {/* Become a Dealer */}
          <div className="dlr-become-box">
            <div className="dlr-become-inner">
              <h2>Become a Dealer</h2>
              <p>We are all India Distributors of ZINGA Film Galvanization. Interested in partnering with us? Fill out our dealership enquiry form.</p>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdyjYNSJzRI0DR6Tu0VxY16GXRWcnOznQPWsMnbH1gLk8rlrw/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
                className="dlr-become-btn"
              >
                Apply for Dealership
              </a>
              <div className="dlr-contact-alt">
                <p>Or contact us directly</p>
                <a href="/contact" className="dlr-contact-btn">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Dealers;
